import React, { createContext, useContext, useState } from 'react';

// User 타입 정의
export interface User {
  userid: string;
  branchcode: number;
  department: string;
  position: string;
  name: string;
  email: string;
  tel: string;
  usertype: string;
  state: string;
  regdate: string;
  notification: string;
  login_type: string;
  img: string;
}

// Context의 기본 값 타입
interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

// Context 생성
const UserContext = createContext<UserContextType | undefined>(undefined);

// Provider 컴포넌트
export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>({
    userid: '',
    branchcode: 0,
    department: '',
    position: '',
    name: '',
    email: '',
    tel: '',
    usertype: '',
    state: '',
    regdate: '',
    notification: '',
    login_type: '',
    img: '',
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom Hook
export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
